export default function getShopifyGlobalId(id, nodeType = "ProductVariant") {
  return `gid://shopify/${nodeType}/${id}`;
}
